import { atom, useAtom } from 'jotai';
import { DrawerNav } from './DrawerContent/const';
import { CSS_TRANSITION_DELAY } from './DrawerContent/const';

const drawerStateAtom = atom<boolean>(false);
const drawerContentAtom = atom<DrawerNav>(DrawerNav.DEFAULT_NAVIGATION);

export const useDrawerContentAtom = () => {
    const [drawerContent, setContent] = useAtom(drawerContentAtom);
    const setDrawerContent = (type: DrawerNav) => {
        setContent(DrawerNav.TRANSIT_CONTENT);
        setTimeout(() => setContent(type), CSS_TRANSITION_DELAY);
    };
    return { setDrawerContent, drawerContent };
};

export const useDrawerStateAtom = () => {
    const [drawerContent, setDrawerContent] = useAtom(drawerContentAtom);
    const [drawerState, setDrawerStateAtom] = useAtom(drawerStateAtom);
    const setDrawerState = (state: boolean) => {
        if (drawerContent !== DrawerNav.DEFAULT_NAVIGATION && state) {
            setDrawerContent(DrawerNav.DEFAULT_NAVIGATION);
        }
        setDrawerStateAtom(state);
    };

    return { drawerState, setDrawerState };
};
